import React, {useContext, useEffect} from "react";
import Tooltip from "../../Common/Tooltip";
import {AlertTriangle, Bell, HelpCircle, X} from "react-feather";
import moment from "moment";
import {AuthContext} from "../../../context/AuthContext";
import {VendorFavicon} from "../../Icons/VendorFavicon";

const ProjectClosed = ({reminders}) => {

    const {baseUrl, id} = useContext(AuthContext);

    const fromData = moment().subtract(18, 'months').format('MM/DD/YYYY');
    const toData = moment().subtract(6, 'months').format('MM/DD/YYYY');
    const url = `${baseUrl}/project/list?created_date_from=${fromData}&created_date_to=${toData}&status=pending&primary_account=${id}`;


    return <div className="sl-px-12 sl-pb-12 sl-w-full">
        <div
            className="sl-bg-warning-25 sl-border-warning-300 sl-border-all sl-rounded-lg sl-p-4 sl-flex sl-flex-col sl-gap-3">
            <div className="sl-flex  sl-gap-3 sl-justify-start sl-align-start">
                <AlertTriangle className="sl-icon sl-w-5 sl-h-5 sl-font sl-text-warning-600"/>
                <div className="sl-font-semibold sl-text-sm sl-text-gray-700">
                    There are <a
                    className="sl-underline-i sl-font-semibold-i sl-text-gray-700-i"
                    href={url}> {reminders.count_project_close}
                    {' '}project{reminders.count_project_close > 1 ? 's' : ''}</a> that need to be
                    closed.
                </div>
            </div>
        </div>
    </div>
}



const RemindersWrap = ({remindersData, onClose}) => {

    const popupRef = React.useRef();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    });

    return (
        <div
            ref={popupRef}
            className="sl-absolute sl-w-100  sl-top-10 sl-right-0 sl-border-radius-8 sl-bg-white sl-shadow-xl sl-border-solid sl-border-1 sl-border-gray-100">
            <div className=" sl-w-full">

                <div className="sl-flex sl-justify-space-between sl-align-center sl-gap-2 sl-pr-12">
                    <div
                        className="sl-grow-1 sl-flex sl-justify-start sl-align-center sl-pt-20 sl-pl-20 sl-pb-12 sl-gap-2">
                        <div className="sl-text-xl sl-font-semibold sl-text-gray-900">Reminders</div>


                        <Tooltip disabled={false}
                                 content={`Here you will see any
                                    project
                                    related "to-dos" that are awaiting your response`}>
                            <HelpCircle size={16}
                                        className="sl-cursor-pointer sl-text-gray-base"/>
                        </Tooltip>


                    </div>
                    <X size={20} className={"sl-cursor-pointer"} onClick={onClose}/>
                </div>


                <div>

                    <div
                        className="sl-customized-scrollbar sl-overflow-y-auto sl-max-h-169i sl-w-full sl-h-auto sl-gap-0 sl-p-2">
                        {remindersData.count_project_close > 0 && <ProjectClosed reminders={remindersData}/>}


                        {remindersData.count === 0 && (
                            <div id="empty" className="sl-flex sl-flex-col sl-justify-center sl-align-center sl-gap-3">
                                <Bell className="sl-h-8 sl-w-8 sl-text-gray-400"></Bell>
                                <div className="sl-text-sm sl-font-medium sl-text-gray-400">No new reminders.</div>
                            </div>)}

                        {remindersData.count > 0 && (
                            <div className="sl-flex sl-flex-col sl-gap-1 sl-w-full">
                                {remindersData.count_project_close > 0 && (
                                    <div className=" sl-px-12">
                                        <div className="sl-flex sl-gap-2 sl-align-center sl-justify-center sl-w-full">
                                            <div
                                                className="sl-content-divider sl-grow-1 sl-h-0-point-25 sl-bg-gray-200"></div>
                                            <div className="sl-text-sm sl-font-normal sl-text-gray-600">New questions
                                                posted
                                            </div>
                                            <div
                                                className="sl-content-divider sl-grow-1 sl-h-0-point-25 sl-bg-gray-200"></div>
                                        </div>
                                    </div>
                                )}


                                {remindersData.reminders.map((reminder, index) => {


                                    return <a key={index}
                                              rel={"noreferrer"}
                                              target="_blank"
                                              href={reminder.employer_survey_ab.link + '?reminderId=' + reminder.id}
                                              className="question-link sl-p-3 sl-flex sl-align-center sl-justify-start sl-gap-3 sl-hover-gray-50 sl-border-radius-8">

                                        <div className="sl-rounded-full sl-border-all sl-p-1 sl-h-11 sl-w-11 sl-p-2 sl-flex">
                                            <VendorFavicon vendor={reminder.vendor}/>
                                        </div>
                                        <div className="sl-flex sl-flex-col sl-text-left">

                                            <div className="sl-flex sl-justify-start sl-align-center sl-gap-2">
                                            <span
                                                className="sl-text-sm sl-font-semibold sl-text-gray-700">{reminder.vendor.name}</span>
                                                <span
                                                    className="sl-text-xs sl-font-normal sl-text-gray-400">{reminder.time}</span>
                                            </div>

                                            <span className="sl-text-sm sl-font-medium">
                                             <span className=" sl-text-gray-base"> Posted a question in </span>
                                              <span
                                                  className="sl-flex-inline sl-text-gray-700">{reminder.employer_survey_ab.search_title}</span>
                                         </span>

                                            {reminder.employer_survey_ab.alert_due && (
                                                <div
                                                    className="sl-flex sl-align-center sl-justify-start sl-gap-2 sl-text-error-700 sl-text-sm sl-font-normal sl-mt-2">
                                                    <i className="sl-icon sl-w-5 sl-h-5"
                                                       data-feather="alert-circle"></i>
                                                    <div className="sl-text-error-700 sl-text-sm sl-font-normal">
                                                        Proposals due in
                                                        {reminder.employer_survey_ab.due_in_days}
                                                        day{reminder.employer_survey_ab.due_in_days > 1 ? 's' : ''}
                                                    </div>
                                                </div>
                                            )}

                                        </div>
                                    </a>
                                })}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
        ;
}

export default RemindersWrap;
